import { PageType } from 'api/page-template/types';
import { useGetSectionPreviewQuery } from 'queries/templates/queries';
import React from 'react';
import { SectionPreview } from 'components/common';
import { useMeetingPreviewStreaming } from './hooks/use-meeting-preview-streaming';

interface MeetingPreviewProps {
  meetingId: number;
  meetingName: string;
  payload: object;
  onBack?: () => void;
  streaming?: boolean;
}

export const MeetingPreview: React.FC<MeetingPreviewProps> = ({
  meetingId,
  meetingName,
  payload,
  onBack,
  streaming = true,
}) => {
  const { data: previewData, isLoading } = useGetSectionPreviewQuery({
    meetingId,
    pageType: PageType.Meeting,
    enabled: true,
    streaming,
    payload: payload,
  });

  const {
    isInitializingStream,
    streamedContent,
    onInitialization,
    thinkingLogs,
  } = useMeetingPreviewStreaming({
    meetingId,
    streaming,
    token: previewData?.streamingMeta?.token,
    channelName: previewData?.streamingMeta?.channelName,
    previewContent: previewData?.finalContent,
  });

  return (
    <SectionPreview
      title={meetingName}
      isLoading={isLoading}
      isInitializingStream={isInitializingStream}
      streaming={streaming}
      content={streamedContent ?? previewData?.finalContent}
      thinkingLogs={thinkingLogs}
      onBack={onBack}
      onInitialization={onInitialization}
    />
  );
};
